<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" translate>
    @if(user){
      <span translate>EDIT</span>
    }@else{
      <span translate>ADD</span>
    }
   </h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body create-api-user" >
  @if (!loading) {
    <div class="row">
      <div class="col-6">
        <div [formGroup]="userForm">
          <lib-gung-text-input suppressLabel=true formControlName="username" placeholder="USERNAME" [renderStatic]="user"/>
          <lib-forms-message-error [controller]="userForm.get('username')"/>
        </div>
      </div>
      <div class="col-6">
        @if(!user){
          <span class="pt-1 d-block">
            &#64;{{suffix}}
          </span>
        }
        
        
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-6">
        <div>
          <lib-gung-password-input
            [enablePasswordRequirement]="true"
            [suppressLabel]="true"
            gungTranslate="PASSWORD"
            [placeholder]="'PASSWORD' | translate"
            [(ngModel)]="password"
            (validPassword)="isValid($event)"
            [passwordRequirement]="passwordRequirements"
          ></lib-gung-password-input>
          <lib-forms-message-error [controller]="userForm.get('password')"/>
        </div>
      </div>
      <div class="col-6">
        <gung-button
          classes="btn-primary "
          label="{{ 'GENERATE_PASSWORD' | translate }}"
          [onClick]="generatePassword.bind(this)"
        />
      </div>
    </div>
    <table class="mt-3 table table-borderless table-striped table-hover">
      <thead>
        <tr>
          <th translate>ACCESS</th>
          <th translate>READ</th>
          <th translate>WRITE</th>
          <th translate>DATA_TRANSFORMER</th>
        </tr>
      </thead>
      <tbody>
        @for (entity of entities; track entity.entity) {
          <tr>
            <td>
              {{ entity.entity }}
            </td>
            <td>
              <lib-gung-checkbox-input-horizontal
                [(ngModel)]="entitiesModel[entity.entity].read"
                suppressLabel="true"
              />
            </td>
            <td>
              <lib-gung-checkbox-input-horizontal
              [(ngModel)]="entitiesModel[entity.entity].write"
              suppressLabel="true"
            />
            </td>
            <td >
              @if(entitiesModel[entity.entity].write){
                <lib-gung-text-input suppressLabel=true [(ngModel)]="entitiesModel[entity.entity].transformer" placeholder="{{'DEFAULT'|translate}}"/>
              }@else{
                <div class="text-center">-</div>
              }
              
            </td>
          </tr>
        }
      </tbody>
    </table>
    
    
  }
</div>
<div class="modal-footer">
  <div class="row w-100">
    <div class="col-12">
      <div class="btn-group btn-group-justified w-100">
        <button class="btn btn-sm btn-outline-secondary btn-default" (click)="activeModal.dismiss()" translate>
          CANCEL
        </button>
        <button class="btn btn-sm btn-primary btn-default" (click)="save($event)" translate>SAVE</button>
      </div>
    </div>
  </div>
</div>
